import React, { FC, useContext, useState } from 'react'
import {
    StyledSettingScreen,
    StyledSettingHeader,
    StyledSettingBody,
    StyledSettingOption,
} from './SettingScreen.styled'
import { IconChevronRightTN } from '../../icons/IconChevronRightTN/IconChevronRightTN'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { ScreenType } from '../hooks/useScreen'

interface SettingOptionProps {
    label: string
    text: string
    onClick: () => void
    isActive?: boolean
}

const SettingOption: FC<SettingOptionProps> = ({
    label,
    text,
    isActive,
    onClick,
}) => {
    return (
        <StyledSettingOption isActive={isActive} onClick={onClick}>
            <span>{label}</span>
            <div>
                <p>{text}</p>
                <IconChevronRightTN />
            </div>
        </StyledSettingOption>
    )
}

export const SettingScreen = () => {
    const authState = useSelector((state: AppState) => state.authentication)
    const { userName, userEmail } = authState
    const { setScreenSelected, setScreen, isScreenSelected } =
        useContext(MyAccountContext)
    const [activeIndex, setActiveIndex] = useState<number>(0)
    // Auth0 defaults userName as email
    const hasName = userName !== userEmail
    function onMenuItemClick(index: number, screen: ScreenType) {
        setScreenSelected(true)
        setScreen(screen)
        setActiveIndex(index)
    }
    const menuItems: {
        label: string
        text: string
        screen: ScreenType
    }[] = [
        {
            label: 'Account',
            text: 'Manage account',
            screen: 'manage-account',
        },
        // We want to hide this option below, for now,
        // but it is reserved for Phase 2 (Post Launch)
        // when finishing up the Newsletter feature
        /* {
            label: 'Email Preferences',
            text: 'Newsletters',
            screen: 'manage-account',
        }, */
    ]

    return (
        <StyledSettingScreen show={!isScreenSelected}>
            <h2>Settings</h2>
            {hasName && <h3>{userName}</h3>}
            <StyledSettingHeader>
                <li>
                    <small>Email</small>
                    <p>{userEmail}</p>
                </li>
            </StyledSettingHeader>
            <StyledSettingBody>
                {menuItems.map((item, index) => (
                    <SettingOption
                        key={index}
                        label={item.label}
                        text={item.text}
                        isActive={index === activeIndex}
                        onClick={() => onMenuItemClick(index, item.screen)}
                    />
                ))}
            </StyledSettingBody>
        </StyledSettingScreen>
    )
}
